import DeploiementForm from './DeploiementForm';
import DeploiementReportsList from './DeploiementReportsList';
import SyncCamDeploiementSkeleton from './SyncCamDeploiementSkeleton';
import SitewebForm from '../deploiementsSiteweb/SitewebForm';
import SitewebReportsList from '../deploiementsSiteweb/SitewebReportsList';

export const assistantsDeploiement = [
  {
    id: 'plateforme-web',
    titre: 'Plateforme Web',
    statut: 'disponible',
    resume: 'Assistant existant pour les validations Plesk, base de donnees, runbook migration + Publish et decision finale.',
    chemin: '/Ingenierie/Deploiements/assistant/plateforme-web',
    libelleNouveau: 'Nouveau deploiement',
    libelleHistorique: 'Historique rapports',
    etapes: [
      'Contexte',
      'Validation Plesk',
      'Validation base de donnees',
      'Runbook migration + Publish',
      'Validation post-deploiement',
      'Decision',
      'Resume',
    ],
    composants: {
      Formulaire: DeploiementForm,
      Historique: DeploiementReportsList,
    },
    logiqueMetier: {
      typeRapport: 'deploiement_plateformeweb',
      brouillon: 'deploiement_plateformeweb_brouillon_v1',
      conserveComportementExistant: true,
    },
    validations: [
      'Contexte obligatoire',
      'Controles Plesk complets',
      'Validation DB et rollback si migration sensible',
      'Runbook DEV puis PROD complet',
      'Validation post-deploiement complete',
      'Decision finale renseignee',
    ],
  },
  {
    id: 'site-web',
    titre: 'Site Web',
    statut: 'disponible',
    resume: 'Assistant existant pour la procedure guidee scriptTransfert.sh, ses controles prealables et son historique.',
    chemin: '/Ingenierie/Deploiements/assistant/site-web',
    libelleNouveau: 'Nouveau deploiement siteweb',
    libelleHistorique: 'Historique rapports siteweb',
    etapes: [
      'Contexte',
      'Avant deploiement',
      'Pendant deploiement',
      'Apres deploiement',
      'Decision',
      'Resume',
    ],
    composants: {
      Formulaire: SitewebForm,
      Historique: SitewebReportsList,
    },
    logiqueMetier: {
      typeRapport: 'deploiement_siteweb',
      brouillon: 'deploiement_siteweb_brouillon_v1',
      conserveComportementExistant: true,
    },
    validations: [
      'Contexte obligatoire',
      'Controles pre-deploiement scriptTransfert.sh',
      'Execution documentee',
      'Validation post-deploiement complete',
      'Decision finale renseignee',
    ],
  },
  {
    id: 'synccam',
    titre: 'SyncCam',
    statut: 'disponible',
    resume: 'Assistant de promotion SyncCam centre sur l identification de la release, les gates fonctionnels et l observation post-deploiement.',
    chemin: '/Ingenierie/Deploiements/assistant/synccam',
    libelleNouveau: 'Nouveau deploiement SyncCam',
    libelleHistorique: 'Historique rapports SyncCam',
    etapes: [
      'Qualification',
      'Gates SyncCam',
      'Decision',
      'Observation',
      'Resume',
    ],
    composants: {
      Formulaire: SyncCamDeploiementSkeleton,
      Historique: DeploiementReportsList,
    },
    logiqueMetier: {
      typeRapport: 'deploiement_synccam',
      brouillon: 'deploiement_synccam_brouillon_v1',
      role: 'orchestrateur_preuves',
      procedureValidationRetrouvee: true,
    },
    validations: [
      'Qualification release complete',
      'Huit gates fonctionnels SyncCam statues avec preuves',
      'Decision de promotion explicite',
      'Observation post-deploiement prevue pour les releases promues',
    ],
  },
  {
    id: 'syncstatsref',
    titre: 'SyncStatsRef',
    statut: 'a_venir',
    resume: 'Assistant prevu pour une prochaine iteration.',
    chemin: '',
    etapes: [],
    composants: {},
    logiqueMetier: {},
    validations: [],
  },
];

export const obtenirAssistantDeploiement = (id) => assistantsDeploiement.find((assistant) => assistant.id === id);



// WEBPACK FOOTER //
// src/components/deploiements/assistantsDeploiement.js